import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ManageFavoritesComponent } from '../../../../manage-favorites/manage-favorites.component';
import { FavoriteLines } from 'src/app/modules/route-planner/interfaces/favorites/favorite-lines.interface';
import { FavoriteLine } from 'src/app/modules/route-planner/interfaces/favorites/favorite-line.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { DIDNT_ADD_FAVORITE_LINES, EDIT, FAVORITE_LINES, LAST_SEARCHES } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';

@Component({
    selector: 'app-favorite-lines',
    templateUrl: './favorite-lines.component.html',
    styleUrls: ['./favorite-lines.component.scss'],
    standalone: false
})
export class FavoriteLinesComponent implements OnInit {
  @Output() onFavoriteLineClick = new EventEmitter<FavoriteLine>();

  favoriteLines: FavoriteLines;

  lastSearchesText: string
  favoriteLinesText: string
  editText: string
  didntAddFavoriteLinesTextPart1: string
  didntAddFavoriteLinesTextPart2: string

  direction: Direction

  constructor(
    private readonly routePlanningService: RoutePlanningService,
    private readonly favoritesService: FavoritesService,
    private readonly languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.favoriteLines = this.favoritesService.favorites
      ?.lines;

    this.favoritesService.onFavoritesChange$.subscribe((favorites) => {
      this.favoriteLines = favorites?.lines;
    });
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.lastSearchesText = LAST_SEARCHES[language.language]
      this.favoriteLinesText = FAVORITE_LINES[language.language]
      this.editText = EDIT[language.language]
      const text = DIDNT_ADD_FAVORITE_LINES[language.language];
      const words = text.split(' ');
      this.didntAddFavoriteLinesTextPart1 = words.slice(0, 3).join(' ');
      this.didntAddFavoriteLinesTextPart2 = words.slice(3).join(' ');
    })
  }

  /** Accessible name for last-searches / favorites list rows (keyboard + SR). */
  lineRowAriaLabel(line: FavoriteLine | undefined | null): string {
    if (!line) {
      return '';
    }
    const parts = [line.routeName, line.cityName, line.agencyName].filter(
      (p) => !!p && String(p).trim().length > 0
    );
    return parts.join(', ');
  }

  openEditFavoritesMenu() {
    this.routePlanningService._componentOverlaySub.next({
      componentType: ManageFavoritesComponent,
      data: {
        closeCallbackFn: (reOpen: boolean) => {
          if(reOpen) {
            this.openEditFavoritesMenu();
          }
          else {
            this.favoriteLines = this.favoritesService.favorites.lines;
          }
        },
      },
    });
  }
}
